export const variantText = (item) =>
  [item?.size && `Mărime: ${item.size}`, item?.color && `Culoare: ${item.color}`]
    .filter(Boolean).join(' · ');

export const VariantLabel = ({ item, className = 'text-xs font-medium text-gray-700', testId }) => {
  const text = variantText(item);
  if (!text) return null;
  return <p className={className} data-testid={testId || 'item-variant'}>{text}</p>;
};
